export const MAIN_TAB_ID = 'main-tab';
